<template>
  <div class="component">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import 'normalize.css';
import '@/assets/css/app.css';

export default defineComponent({});
</script>
